import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { UserService } from '../../services/user.service';

@Injectable()
export class LoginRedirectGuard implements CanActivate {
    constructor(private router: Router, private userService: UserService) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        var user_email = localStorage.getItem('email');
        if (!user_email) {
            var refreshUrl = '/home';
            this.router.navigateByUrl(refreshUrl).then(() => this.router.navigate(['/']));
            return false;
        } else {
            var user_data: any = this.userService.getCurrentUser(user_email);
            if (user_data) {
                return true;
            }
        }
        return false;
    }
}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/services/auth/login-redirect.guard.ts